<script setup>
  import ModalSiteSettings from '@/components/ModalSiteSettings.vue';
</script>

<template>
  <ModalSiteSettings />
</template>